export const staggerDelay = (index: number, stepMs = 40, maxMs = 320) => ({
    animationDelay: `${Math.min(index * stepMs, maxMs)}ms`,
});
